export default __webpack_public_path__ + "static/media/celo_square_logo.2ca4ce8b.svg";